import { useEffect, useState } from 'react'

// A piece of state that outlives the page, the way the dark-mode setting does.
//
// `src/theme/ThemeContext.js` was the only persisted preference in the app, and it is a context
// because the theme is global — every component needs it. A preference that belongs to one section
// does not need a context, but it does need the same two habits: read the stored value lazily so
// the first render is already correct (no flicker into the wrong view), and treat storage as
// something that can fail. In a private window, with site data blocked, or over quota, both the
// read and the write throw, and a preference is never worth breaking a page over.
export const usePersistedState = (key, fallback) => {
  const [value, setValue] = useState(() => {
    try {
      const stored = window.localStorage.getItem(key)
      return stored === null ? fallback : JSON.parse(stored)
    } catch (e) {
      return fallback
    }
  })

  useEffect(() => {
    try {
      window.localStorage.setItem(key, JSON.stringify(value))
    } catch (e) {
      /* private mode, blocked site data, quota — the preference just will not stick */
    }
  }, [key, value])

  return [value, setValue]
}

export default usePersistedState
